import { render } from "./FileNode.vue?vue&type=template&id=1b971a2e&ts=true"
import script from "./FileNode.vue?vue&type=script&lang=ts"
export * from "./FileNode.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__